module.exports = __webpack_public_path__ + "static/media/done.81abb8ec.gif";